let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1fY0H")).then(() => parcelRequire('FRRBu'));